import { GrantsType, hasScopedPermission } from '../../Shared/utils/auth';
import { CurrentUserData } from 'Auth/components/AuthProvider/AuthProvider';

export const updateProtectedAttributes = (grants: GrantsType) =>
  hasScopedPermission(
    grants,
    'partner',
    'partners.protected_attributes.update'
  ) ||
  hasScopedPermission(grants, 'system', 'partners.protected_attributes.update');

export const updatePartnerAncestryPolicy = (
  currentUser: CurrentUserData['currentUser']
) =>
  (currentUser.isCarrierUser || currentUser.isSystemUser) &&
  (hasScopedPermission(
    currentUser.effectiveGrants,
    'partner',
    'partners.update'
  ) ||
    hasScopedPermission(
      currentUser.effectiveGrants,
      'system',
      'partners.update'
    ));
